module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Twitter.b52508ec.svg";